module.exports = __webpack_public_path__ + "static/media/Shop-By-Vehicle-Icon.fd165e9d.svg";